/**
 * Action types
 * @property {string} MODAL_FIND_OPEN
 */
export const types = {
  MODAL_FIND: "MODAL_FIND",
};

/**
 * @namespace Reducers
 */
export const reducers = {
  modalFindOpen: (state = false, action) => {
    switch (action.type) {
      case types.MODAL_FIND:
        return !state;
      default:
        return state;
    }
  },
};

/**
 * @namespace Actions
 */
export const actions = {
  /**
   * Handle interactions with Find This for Me modal
   * @memberof Actions
   */
  handle: () => ({
    type: types.MODAL_FIND,
  }),
};
